import { observable, action } from "mobx";

const Store = observable(
  {
    easypay_payments: null,
    query: "",
    advancedFilter: false,
    page: 0,
    searchValues: {
      payments_processed: false,
    },
    setPage(page) {
      this.page = page;
    },
    setQuery(query) {
      this.query = query;
    },
    setSearchValues(vals) {
      this.searchValues = vals;
    },
    setCount(count) {
      this.count = count;
    },
    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
    setEasypayPayments(easypay_payments) {
      this.easypay_payments = easypay_payments;
    },
  },
  {
    setPage: action,
    setQuery: action,
    setCount: action,
    setSearchValues: action,
    setEasypayPayments: action,
  }
);

export default Store;
